import React, { useState } from "react";
import { ethers } from "ethers";
import { Input, Button } from "@airdao/ui-library";
import { checkValidNumberString } from "../../../../services/numbers";

const percents = [25, 50, 75, 100];

const AmountInput = ({
  inputError = false,
  inputValue,
  setInputValue,
  balance,
  placeholder,
  label,
  disabled,
  fullWithdrawal,
}) => {
  const [percent, setPercent] = useState(0);

  const handleChange = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (
      e.target.value === "" ||
      (/^[\d.]*$/.test(e.target.value) &&
        checkValidNumberString(e.target.value))
    ) {
      setInputValue(e.target.value);
    }
    setPercent(0);
    if (fullWithdrawal) {
      fullWithdrawal(false);
    }
  };

  const handlePercent = (value) => {
    if (value === 100 && fullWithdrawal) {
      fullWithdrawal(true)
    }
    const parsedBalance = ethers.utils.formatEther(balance);
    setInputValue(Math.floor(parsedBalance * (value / 100)));
    setPercent(value);
  };

  return (
    <div className="deposit__actions">
      <Input
        onChange={handleChange}
        placeholder={placeholder}
        value={inputValue}
        label={label}
        className={"pool__input"}
        error={inputError && "A minimum of 1000 AMB is required to stake."}
        tailIcon={<div className={"pool__input-badge"}>AMB</div>}
        disabled={disabled}
      />

      <div className="deposit__buttons">
        {percents.map((el) => (
          <Button
            type="tetiary"
            size="large"
            key={el}
            disabled={balance.isZero() || disabled}
            onClick={() => handlePercent(el)}
            className={`deposit__percent-button ${
              el === percent ? "deposit__percent-button_active" : ""
            }`}
          >
            {el + "%"}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default AmountInput;
